// extracted by mini-css-extract-plugin
export var list = "index-module--list--bn64A";
export var listItem = "index-module--list-item--2AnDC";
export var note = "index-module--note--7P9k1";